import { Pin, X, ChevronDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export default function PinnedBar({ pinned, onUnpin, accent, canModerate = true }) {
  if (!pinned || pinned.length === 0) return null;
  const latest = pinned[0];

  return (
    <div
      data-testid="pinned-bar"
      className="px-4 py-2 bg-indigo-50 dark:bg-indigo-950/40 border-b border-indigo-200 dark:border-indigo-500/20 flex items-center gap-2.5 shrink-0"
    >
      <Pin className="w-4 h-4 shrink-0" style={{ color: accent || "#6366f1" }} />
      <div className="min-w-0 flex-1">
        <p className="text-[10px] font-semibold uppercase tracking-wide" style={{ color: accent || "#6366f1" }}>
          Pesan tersemat{pinned.length > 1 ? ` · ${pinned.length}` : ""}
        </p>
        <p className="text-xs text-slate-600 dark:text-slate-300 truncate">
          <span className="font-semibold text-emerald-600 dark:text-emerald-400">{latest.username}:</span>{" "}
          {latest.text || "📷 Gambar"}
        </p>
      </div>
      <Popover>
        <PopoverTrigger asChild>
          <button data-testid="pinned-list-toggle" className="p-1 rounded text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white transition-colors">
            <ChevronDown className="w-4 h-4" />
          </button>
        </PopoverTrigger>
        <PopoverContent align="end" className="z-[10000] w-80 p-2 bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-800 space-y-1 max-h-72 overflow-y-auto">
          <p className="text-xs font-semibold text-slate-500 dark:text-slate-400 px-1 mb-1 uppercase tracking-wide">Pesan tersemat</p>
          {pinned.map((p) => (
            <div key={p.id} data-testid={`pinned-item-${p.id}`} className="flex items-start gap-2 px-2 py-1.5 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800">
              <div className="min-w-0 flex-1">
                <p className="text-xs font-semibold text-emerald-600 dark:text-emerald-400">{p.username}</p>
                <p className="text-xs text-slate-600 dark:text-slate-300 break-words">{p.text || "📷 Gambar"}</p>
              </div>
              {canModerate && (
                <button
                  data-testid={`unpin-${p.id}`}
                  onClick={() => onUnpin(p.id)}
                  className="p-1 rounded text-slate-400 hover:text-rose-500 shrink-0 transition-colors"
                >
                  <X className="w-3.5 h-3.5" />
                </button>
              )}
            </div>
          ))}
        </PopoverContent>
      </Popover>
    </div>
  );
}
